export const MAX_ALLOWED_GROUPS = 5;
